import React, { Component } from 'react'
import { i18nTranslate } from 'src/utils'
import { Button, Modal } from 'react-bootstrap'
import './styles.scss'

class AccountConvertedFailPopup extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const {
      isToShowPopUp = true,
      checkAccountConversionApiStatus,
      handleShowAccountConvertedFailModalClose,
    } = this.props

    return (
      <Modal
        show={isToShowPopUp}
        className="conversion-disclaimer-modal rounded-md modal-dialog-centered">
        <Modal.Body className="conversion-disclaimer-modal">
          {checkAccountConversionApiStatus ? (
            <>
              <p className="conversion-disclaimer-modal-content">
                {i18nTranslate(
                  'ba_to_member_unable_to_process_reques',
                  'We were unable to process your request to become a Member due to an unexpected error. Please try again.'
                )}
              </p>
            </>
          ) : (
            <>
              <h4 className="conversion-disclaimer-modal-title">
                {i18nTranslate(
                  'ba_to_member_become_a_member_failure_title',
                  'Sorry, you are unable to switch to a Member at this time.'
                )}
              </h4>
              {i18nTranslate(
                'ba_to_member_failure_error_message',
                'This could be because your account is a Business Entity or Joint Brand Affiliate, your account has a hold, or the commission run began during this switch. If you have any questions, please contact customer support.'
              )}
            </>
          )}

          <div className="row">
            <div className="col-12">
              <Button
                className="cancel-button rounded-md w-100"
                variant="outline-primary"
                data-testid="qa-exit-cancel-button"
                block
                onClick={handleShowAccountConvertedFailModalClose}>
                {i18nTranslate('ba_to_member_close', 'Close')}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    )
  }
}

export default AccountConvertedFailPopup
export { AccountConvertedFailPopup }
